<template>
  <div class="myinvoice-view right_auth">
    <div class="time">
      <label>订单时间： </label>
      <sd-select :options="options" :open="open"
                 @changeOpen="open =! open" :value="dateRange" @changeOption="changeRange"></sd-select>
    </div>
    <div v-if="list.length">
      <table>
        <colgroup>
          <col class="money_col">
          <col class="time_col">
          <col class="genre_col">
          <col class="head_col">
          <col class="item_col">
          <col class="state_col">
        </colgroup>
        <thead>
        <tr>
          <td>发票金额</td>
          <td>申请时间</td>
          <td>发票类型</td>
          <td>发票抬头</td>
          <td>项目名称</td>
          <td>开票状态</td>
        </tr>
        </thead>
        <tbody>
        <tr v-for="li in list">
          <td class="red">￥{{li.customerAmount}}</td>
          <td>{{li.createTime | time2}}</td>
          <td>{{li.invoiceType | invoiceType}}</td>
          <td>{{li.invoiceTitle}}</td>
          <td>{{li.invoiceName}}</td>
          <td v-if="!li.onlinePath">{{li.invoiceStatus | invoiceStatus}}</td>
          <td v-else><a class="down_pdf" :href="li.onlinePath | OSS" target="_blank">下载电子票</a></td>
        </tr>
        </tbody>
      </table>
      <div class="page_wrap">
        <sd-pager ref="pager" :page-data="page" @page-change="pageChange"></sd-pager>
      </div>
    </div>
    <div class="g_empty" v-if="!list.length">
      <p class="info">没有检测到相关的发票~</p>
    </div>
  </div>
</template>
<script>
  import sdSelect from '../components/sdSelect'
  import {util} from '../service/util'
  import { mapState, mapActions , mapGetters} from 'vuex'
  import moment from 'moment'
  import sdPager from '../components/sdPager.vue'
  let API = util.api(['GETTRANINVOICEBYSEARCH']);
  export default{
    components:{sdSelect,sdPager},
    data(){
      return {
        options:[
          {
            label:'全部',
            param:{

            }
          },
          {
            label:'近三个月订单',
            param:{
              beginTime : moment().subtract(3,'month').format('YYYY-MM-01'),
              endTime : moment().format('YYYY-MM-DD HH:mm:ss')
            }
          },
          {
            label:'近六个月订单',
            param:{
              beginTime : moment().subtract(6,'month').format('YYYY-MM-01'),
              endTime : moment().format('YYYY-MM-DD HH:mm:ss')
            }
          },
          {
            label:'一年前的订单',
            param:{
              endTime : moment().subtract(1,'year').format('YYYY-MM-DD')
            }
          },
        ],
        open:false,
        dateRange: {label: '全部',param:{}},
        list:[],
        page:{
          pageNo:1,
          pageSize:15,
          totalPage:1
        }
      }
    },
    computed:{
      searchTranInvoice(){
        return{
          ...this.dateRange.param,
        }
      },
      paramPage(){
        return{
          ...this.page
        }
      }
    },
    methods:{
      changeRange(data){
        this.dateRange = data;
        this.open = !this.open;
        this.page = this.$options.data().page;
        this.search();
      },
      pageChange(){
        this.search();
      },
      search(){
        let _this = this;
        util.kAjax(API.GETTRANINVOICEBYSEARCH,{searchTranInvoice:_this.searchTranInvoice,page:_this.page},json=>{
          _this.list = json.data.datas;
          this.page.pageNo = json.data.pageNo;
          this.page.totalPage = json.data.totalPage;
        });
      }
    },
    mounted(){
      this.search();
    }
  }
</script>

<style lang="scss" scoped="">
  .down_pdf{
    color: #ffbe59;
    &:hover{
      color: orange;
      text-decoration: underline;
    }
  }
</style>



// WEBPACK FOOTER //
// MyInvoiceView.vue?d7580dc0